export default "__VITE_PUBLIC_ASSET__0c2e4d7e__"